import React, { useState } from 'react';
import axios from '../axios'; // Use the configured axios instance
import { useNavigate } from 'react-router-dom';
import {Container, Form, FormBtn, FormCover, H3, MediumSpacing} from "../../styles";

const StudentsImport = () => {
    const [file, setFile] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('excel_file', file);

        try {
            const response = await axios.post('/student/import/', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'X-CSRFToken': getCookie('csrftoken'), // Add CSRF token header
                }
            });

            if (response.status === 200) {
                console.log(response.data);
                navigate('/students/');
            }
        } catch (error) {
            console.error("There was an error importing the students!", error);
            setErrorMessage(error.response ? error.response.data.error : 'An error occurred. Please try again.');
        }
    };

    // Function to get the CSRF token from cookies
    const getCookie = (name) => {
        let cookieValue = null;
        if (document.cookie && document.cookie !== '') {
            const cookies = document.cookie.split(';');
            for (let i = 0; i < cookies.length; i++) {
                const cookie = cookies[i].trim();
                // Does this cookie string begin with the name we want?
                if (cookie.substring(0, name.length + 1) === (name + '=')) {
                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return cookieValue;
    };

    return (
        <Container>
            <FormCover>
            <H3>Import Students</H3>
                <MediumSpacing/>
            <Form  onSubmit={handleSubmit} method="post">
                <p>Import students from an Excel file. Only .xlsx files are supported.</p>
                <p><a className="button_underline" href="/assets/template.xlsx" download>Download Template File</a></p>
                <input type="file" name="excel_file" onChange={handleFileChange} required /><br />
                <FormBtn type="submit">Upload File</FormBtn>
                {errorMessage && (
                    <div style={{ color: 'red' }} role="alert">
                        <p>{errorMessage}</p>
                    </div>
                )}
            </Form>
                </FormCover>
        </Container>
    );
};

export default StudentsImport;
